<template>
    <!-- <myNav title="云设备说明"></myNav> -->
    <div class="sendBox-tips">
      <h3>云挂机设备使用方法？</h3>
      <ul>
        <li>1、点击空闲设备后在设备内App或浏览器下载游戏;</li>
        <li>
          2、进入设备后即可正常操作游戏画面设置挂机，挂机设置完成后，即可点击悬浮窗中的【返回】按钮，退出云设备画面，而您的云设备会在云端持续运行，不会中断挂机;
        </li>
        <li>
          3、返回到【云挂机】界面，点击游戏画面重新进入云设备，【刷新】:可随时查看游戏内动态。
        </li>
      </ul>
  
      <h3>云挂机设备是什么，可以做什么？？</h3>
      <p>
        云挂机设备功能是为玩家提供的游戏云端运行功能，用户可以在自己的手机上同时运行不同游戏/不同小号，您可以对多个游戏/小号进行远程操作，实现7*24h云端挂机，挂机过程中不消耗您本地流量及电量。
      </p>
  
      <h3>云设备可安装哪些？</h3>
      <p>云设备安装不限制，可任意安装通过审核的游戏，应用等。</p>
  
      <h3>使用云设备会消耗本地流量吗？</h3>
      <p>
        设备为云端运行，挂机过程中不会消耗本地流量及电量，但是通过APP操作“云设备”，连接设备，传输画面的过程，以及点击刷新画面，会消耗本地流量，此时建议使用WiFi。
      </p>
  
      <h3>云设备画面不够清晰？</h3>
      <p>
        游戏实际在云端服务器上运行，与看视频一样，画面会渲染压缩后再传送到我们手机上，所以在画质上相较于游戏客户端会有损失，画面清晰度会有所降低。
      </p>
  
      <h3>为什么云玩游戏延迟很高或卡顿？</h3>
      <p>
        云设备是远程视频流传输画面，工作原理类似于看视频因此在流畅性上对网络的要求比较高。遇到卡顿，建议切换更稳定的网络，或者将画质调整的最低，游戏内切换为低帧率模式，又或者尝试重启设备。若上述都无法解决，请录屏，联系客服反馈处理。
      </p>
  
      <h3>游戏应用等软件运行问题:</h3>
      <p>
        部分游戏或应用无法安装，安装后无法启动，或启动后出现闪退/卡死等问题，该情况多为设备与游戏应用的兼容性问题，此时您可尝试退出后再次重新启动游戏。如无法解决可更换其他游戏或联系客服反馈处理。
      </p>
    </div>
  </template>
  <style scoped>
  .sendBox-tips {
    padding: 0 32px;
    background-color: #fff;
    overflow: auto;
    padding-bottom: calc(40px + constant(safe-area-inset-bottom));
  
    padding-bottom: calc(40px + env(safe-area-inset-bottom));
  }
  .sendBox-tips h3 {
    margin: 20px 0 20px;
    font-size: 32px;
    color: #333;
  }
  ul {
    color: #333;
  }
  .sendBox-tips p,
  li {
    font-size: 28px;
    color: #999;
  }
  </style>
  